import { PhoneBox } from '@apply/components';
import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';

export const PhoneNumberBField = () => {
    const value = useBrokerDetailsStore((s) => s.phoneNumberB);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    return (
        <PhoneBox
            id='cPhoneNumberB'
            value={value}
            onChange={(v) => updateFields({ phoneNumberB: v })}
            label='Secondary Phone'
            width={'100%'}
        />
    );
};
